import { type TestimonialConfig } from "./testimonial-card/testimonial-card.component";

export const testimonials: TestimonialConfig[] = [
  {
    quote:
      "Personally, I very much appreciate the opportunity to implement my own ideas, communication, relaxed atmosphere, knowledge sharing and community days (for example, robotics workshops).",
    imgUrl: "andri-khaliavkin.webp",
    altDescription: "description of the photo",
    namePosition: "Andrii Khaliavkin | QA Manual Tester",
  },

  {
    quote:
      "NiceProject offers not only interesting projects, but also a great working atmosphere. It is really inspiring and makes me feel that my contribution is really appreciated.",
    imgUrl: "szymon-wisniewski.webp",
    altDescription: "Testimonial 2",
    namePosition: "Szymon Wiśniewski | Frontend Developer",
  },
  {
    quote:
      "NiceProject gives you the opportunity to work with new technologies, in diverse projects and most importantly - with great people!",
    imgUrl: "jerzy-glowacki.webp",
    altDescription: "Testimonial 3",
    namePosition: "Jerzy Głowacki | QA Engineer",
  },
];
